export default __webpack_public_path__ + "static/media/packages.24c5eebc.svg";